<template>
  <div>
    <van-nav-bar
      left-arrow
      :title="title"
      left-text="返回"
      @click-left="hide">
    </van-nav-bar>
    <div style="margin-top: 10px;font-size: 16px;">
      <div>
        <label class="label">车主姓名</label>
        <label v-if="work.ownerName" class="value">{{work.ownerName}}</label>
        <label v-else style="color: #646464;" class="value">无</label>
      </div>
      <div>
        <label class="label">车牌</label><label class="value">{{work.carNo | carNo}}</label>
      </div>
      <div>
        <label class="label">品牌/车型</label><label class="value">{{work.brandName}} / {{work.model}}</label>
      </div>
      <div>
        <label class="label">服务顾问</label><label class="value">{{work.consultantName}}</label>
      </div>
      <div>
        <label class="label">到厂时间</label><label class="value">{{work.enterTime}}</label>
      </div>
      <div>
        <label class="label">交车时间</label>
        <label class="value">{{work.estimateDeliveryTime}}</label>
      </div>
      <div v-if="isInterrupt" key="0">
        <label class="label">中断原因</label>
        <remote-picker class="value"
                       class-name="INTERRUPT_REASON"
                       v-model="request.reasonId">
        </remote-picker>
      </div>
      <div v-else key="1">
        <label class="label">机修技师</label>
        <remote-picker class="value"
                       class-name="MachineTechnician"
                       v-model="request.technicianId">
        </remote-picker>
      </div>
      <div style="display: flex; margin-top: 10px">
        <label class="label" style="flex-shrink: 0">备注</label>
        <el-input style="display: inline-block; margin-right: 50px" type="textarea" v-model="request.remarks" :rows="3"
                  maxlength="200"
                  class="value"
                  resize="none">
        </el-input>
      </div>
      <div style="text-align: center; margin-top: 70px">
        <van-button style="width: 60%" size="normal" type="info" @click="confirm" :loading="confirmLoading">
          {{isInterrupt ? '中断' : '转机修'}}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { Button, Field, NavBar, Toast } from 'vant'
  import RemotePicker from '@/components/selector/RemotePicker'
  import { interruptWork } from '@/utils/request'
  import workStatus from '@/utils/workStatus'
  import authority from '@/utils/authority'

  function Request () {
    this.workId = null
    this.workStatus = null
    this.reasonId = null
    this.technicianId = null
    this.remarks = null
  }

  export default {
    name: 'WxInterruptPage',
    components: {
      RemotePicker,
      [NavBar.name]: NavBar,
      [Field.name]: Field,
      [Button.name]: Button
    },
    props: {
      show: Boolean,
      pattern: {
        type: String, // INTERRUPT, MACHINE_REPAIR
        required: true
      },
      work: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        confirmLoading: false,
        request: new Request()
      }
    },
    methods: {
      hide () {
        this.$emit('update:show', false)
      },
      confirm () {
        if (this.isInterrupt) {
          if (!this.request.reasonId) {
            Toast.fail('请选择中断原因！')
            return
          }
        } else {
          if (!this.request.technicianId) {
            Toast.fail('请选择机修技师！')
            return
          }
        }

        this.request.workId = this.work.id
        this.request.workStatus = workStatus.workStatus
        this.confirmLoading = true
        interruptWork(this.$_.cloneDeep(this.request))
          .then(() => this.hide())
          .finally(() => {
            this.confirmLoading = false
          })
      }
    },
    computed: {
      isInterrupt () {
        return this.pattern === authority.INTERRUPT
      },
      workStatus () {
        return this.isInterrupt ? workStatus.INTERRUPT : workStatus.MACHINE_REPAIR_WAIT
      },
      title () {
        return this.isInterrupt ? '中断工单' : '转机修'
      }
    },
    watch: {
      show: {
        handler () {
          this.request = new Request()
        },
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .label {
    font-size: 15px;
    display: inline-block;
    width: 120px;
    color: #646464;
    text-align: right;
    height: 40px;
    line-height: 40px;
  }

  .value {
    font-size: 16px;
    display: inline-block;
    color: black;
    height: 40px;
    line-height: 40px;
    margin-left: 34px;
  }
</style>
